import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer = () => {
  return (
    <section className="sec-footer">
      <div className="Footer">
        <div className="box-main">
          <div className="box-content">
            <div className="box-info">
              <div className="footer-logo">지온나래</div>
              <p className="footer-desc">
                GIST를 온 세상에 널리 알리는 날개<br />
                공식 학생 홍보대사 지온나래
              </p>
              <div className="footer-contact">
                <p>광주과학기술원 (GIST)</p>
                <p>광주광역시 북구 첨단과기로 123</p>
              {/* <p>Email: <a href="mailto:gionnarae@gist.ac.kr">gionnarae@gist.ac.kr</a></p> */}
            </div>
            </div>

            <div className="box-links">
              <h3 className="footer-title">빠른 링크</h3>
              <div className="footer-link-list">
                <Link to="/about" className="footer-link">
                  지온나래 소개
                </Link>
                <Link to="/guide/life" className="footer-link">
                  새내기 가이드
                </Link>
                <a
                  href="https://www.instagram.com/gist_gionnarae/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  지온나래 인스타그램
                </a>
              </div>
            </div>

            <div className="box-links">
              <h3 className="footer-title">GIST 바로가기</h3>
              <div className="footer-link-list">
                <a
                  href="https://www.gist.ac.kr"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GIST 홈페이지
                </a>
                <a
                  href="https://admission.gist.ac.kr"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GIST 입학처
                </a>
                <a
                  href="https://www.gist.ac.kr/kr/html/sub01/010308.html"
                  className="footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  캠퍼스 투어 신청
                </a>
              </div>
            </div>
          </div>

          <div className="box-copyright">
            <p>&copy; 2026 Gionnarae, GIST. All rights reserved.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
